import React, { useRef } from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';

interface Props {
  revertEnable: any;
  onClick: () => void;
  classes?: any;
}

const RevertToDefault: React.FC<Props> = (props: Props) => {
  const { revertEnable, onClick, classes } = props;

  const revertToDefaultRef = useRef(null);

  const onKeyUp = (e: any) => {
    if (e.key.toLocaleLowerCase() === 'enter')
      revertToDefaultRef.current.click();
  };

  return (
    <button
      onKeyUp={onKeyUp}
      ref={revertToDefaultRef}
      tabIndex={0}
      className={classes.revertToDefault}
      style={{
        opacity: revertEnable ? 1 : 0.5,
      }}
      onClick={onClick}
      type="button"
    >
      Revert to Default
    </button>
  );
};

RevertToDefault.defaultProps = {
  classes: {},
};

export default injectSheet(styleSheet)(RevertToDefault);
